import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ui-svg-icon',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent {
  @Input() svgIcon: string = '';
  @Input() customClass: string = '';
  @Input() size: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' = 'large';
  @Input() rotated: boolean = false;

  useFallback = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['svgIcon'] && this.svgIcon) {
      this.useFallback = false;
      this.iconRegistry.addSvgIcon(
        this.svgIcon,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icones/${this.svgIcon}.svg`),
      );
      this.iconRegistry.getNamedSvgIcon(this.svgIcon).subscribe({
        error: () => (this.useFallback = true),
      });
    }
  }

  get svgIconClass(): string {
    const baseClass = this.size + '-icon ' + `icon-${this.svgIcon.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
    return this.customClass ? `${this.customClass} ${baseClass}` : baseClass;
  }
}
